import { Column } from '../../model/common/column';
import { SelectItem } from '@openng/optimus-ui/api';

export function getCrmShiftTurnoverColumns(
  availableDistricts: SelectItem[],
  types: SelectItem[],
  status: SelectItem[]
): Column[] {
  return [
    {
      field: 'shiftDate',
      header: 'CRM.LABEL.TURNOVER_DATE',
      formatPattern: 'calendar',
      type: 'calendar',
      width: '10%',
      sortable: true,
      filterable: false,
    },
    {
      field: 'aorName',
      header: 'CRM.LABEL.AOR',
      formatPattern: 'text',
      type: 'dropdown',
      width: '10%',
      sortable: true,
      filterable: true,
      options: availableDistricts,
      matchMode: 'equals',
    },
    {
      field: 'shiftName',
      header: 'CRM.LABEL.SHIFT',
      formatPattern: 'text',
      type: 'dropdown',
      width: '15%',
      sortable: true,
      options: types,
      filterable: true,
    },
    {
      field: 'statusLabel',
      header: 'CRM.LABEL.STATUS',
      formatPattern: 'text',
      type: 'dropdown',
      width: '10%',
      sortable: true,
      filterable: true,
      options: status,
    },
    {
      field: 'incomingName',
      header: 'CRM.LABEL.INCOMING_ANALYST',
      formatPattern: 'text',
      width: '20%',
      sortable: true,
      filterable: true,
    },
    {
      field: 'departingName',
      header: 'CRM.LABEL.DEPARTING_ANALYST',
      formatPattern: 'text',
      width: '20%',
      sortable: true,
      filterable: true,
    },
  ];
}
